<template>
<div :class="playerClass">
    <div class="videoWrapper">
        <div id="player" data-vimeo-defer></div>
    </div>
    <a @click.prevent="playVideo(currentPlayer)" class="videoBtn">
        <img v-if="imgPath" :src="imgPath" :alt="video.pagetitle" class="img-responsive">
        <div class="play-icon">
            <img src="../../assets/images/play-icon-big.png" alt="נגן סרטון"
            v-if="!showSpinner">
            <load-spinner v-show="showSpinner"></load-spinner>
        </div>
    </a>
    <video-overlay :video="video" :state="playerState"
     :player="currentPlayer" :nextSeries="nextSeries"
     v-if="showOverlay" v-on:load-next="$emit('load-next')" :isLast="isLast"></video-overlay>
</div>
</template>

<script>
import Player from "@vimeo/player";
import LoadSpinner from "@/components/LoadSpinner.vue";
import VideoOverlay from "./VideoOverlay.vue";

export default {
  name: `MainVideo`,
  props: {
    video: Object,
    base: String,
    isLast: {
      type: Boolean,
      default: false
    },
    nextSeries: Number
  },
  components: {
    LoadSpinner,
    VideoOverlay
  },
  data() {
    return {
      showSpinner: false,
      imgPath: ``,
      playerClass: `main-video`,
      currentPlayer: {
        destroy() {} // prevent video watcher throwing error
      },
      playerState: {
        paused: false,
        ended: false,
        location: {}
      }
    };
  },
  watch: {
    base() {
      if (this.video.videoImg) {
        this.imgPath = `${this.base}assets/yoga/images/videos/${
          this.video.videoImg
        }`;
      }
    },
    video() {
      this.playerClass = `main-video`;
      this.currentPlayer.destroy();
      this.playerState.paused = false;
      this.playerState.ended = false;
      this.imgPath = `${this.base}assets/yoga/images/videos/${
        this.video.videoImg
      }`;
      this.loadVideo();
    }
  },
  beforeUpdate() {
    if (this.video.videoImg) {
      this.imgPath = `${this.base}assets/yoga/images/videos/${
        this.video.videoImg
      }`;
    }
  },

  mounted() {
    if (this.video.videoImg) {
      this.imgPath = `${this.base}assets/yoga/images/videos/${
        this.video.videoImg
      }`;

      this.loadVideo();
    }
  },

  methods: {
    loadVideo() {
      // todo - add error if no video number
      // this.playerClass = `main-video video-before-playing`;
      this.showSpinner = true;
      this.currentPlayer = new Player(`player`, {
        id: this.video.videoNumVimeoFull
      });
      const self = this;
      this.currentPlayer.ready().then(() => {
        // this.playerClass = `main-video video-playing`;
        self.showSpinner = false;
        // the player is ready
        // self.playVideo(self.currentPlayer);
      });
    },

    playVideo(player) {
      this.showSpinner = true;
      player
        .play()
        .then(() => {
          this.playerClass = `main-video video-playing`;
          // this.showSpinner = false;
          this.$store.dispatch(`addToHistory`, this.video.id);
          this.$store.dispatch(`saveExtendedHistory`, this.video.id);
        })
        .catch((error) => {
          this.$store.state.errors.push(error);
        });

      player.on(`ended`, (e) => {
        this.playerState.paused = false;
        this.playerState.ended = true;
        this.playerState.location = e;
        this.$emit(`video-ended`);
      });

      player.on(`pause`, (e) => {
        this.isPaused(player);
        this.playerState.location = e;
      });

      player.on(`play`, () => {
        this.showSpinner = false;
        this.playerState.paused = false;
        this.$emit(`video-playing`);
      });
    },

    isPaused(player) {
      player.getPaused().then((paused) => {
        this.playerState.paused = paused;
      });
    }
  },

  computed: {
    showOverlay() {
      if (this.playerState.paused === true || this.playerState.ended === true) {
        return true;
      }
      return false;
    }
  }
};
</script>

<style>
</style>
